export default "__VITE_ASSET__DBcZxZKK__"